<template>
  <section class="c-section c-section--home">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card>
            <div class="container">
              <div style="height:60vh"
            class="w-100 d-flex align-items-start align-items-lg-center
              justify-content-center flex-column flex-lg-row">
                <div class="w-100 mb-4">
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-1"></b-skeleton>
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-1"></b-skeleton>
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-3"></b-skeleton>
                    <b-skeleton animation="wave" type="button"></b-skeleton>
                </div>
                <div class="w-100 d-none d-lg-flex justify-content-center opacity-0 ">
                  <b-skeleton-img no-aspect width="50%" height="300px">
                  </b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <b-row >
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="70px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="70px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="70px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="70px"></b-skeleton-img>
                </b-col>
              </b-row>
            </div>
          </b-card>
      </template>

      <div v-if="context.banner" class="c-banner" id="slider-banner">
        <div class="c-banner__backgraund">
          <div id="slider-banner" class="c-slider-banner swiper h-100">
            <div class="swiper-wrapper position-relative h-100">
              <div
                v-for="(item, i) of context.banner.galeria"
                :key="`imagen-${i}`"
                class="swiper-slide h-100">
                <img :src="item.imagen" alt="" class="w-100 h-100 of--cover">
              </div>
            </div>
          </div>
        </div>
        <div class="container position-relative h-100">
          <div class="c-banner__text container">
            <div class="row align-items-center h-100">
              <div data-aos="fade-up" class="col-12 col-md-8 col-lg-6">
                <h2 class="white w-black mb-5">
                  {{context.banner.titulo}}
                </h2>
                <div class="d-flex">
                  <a href="#services" class="c-button c-button--primary">
                    {{context.banner.boton_titulo}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-banner__gradient"></div>
        <div class="swiper-pagination" cursor="pointer"></div>
      </div>
      <div v-if="context.atributos" class="c-benefit py-5 overflow-hidden">
        <div class="container">
          <div class="row gy-4 justify-content-center">
            <div
              v-for="(item,i) in context.atributos.slice(0,4)"
              :key="`item-${i}`"
              data-aos="fade-up"
              :data-aos-delay="100 * (i + 1)"
              class="col-6 col-md-4 col-lg-3">
              <div>
                <div class="d-flex justify-content-center mb-4">
                  <figure class="c-benefit__icon">
                    <img :src="item.icono" alt="" class="h-100 of--contain">
                  </figure>
                </div>
                <h2 class="white fs-16 w-medium line-height text-center mb-0">
                  {{item.titulo}}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.nosotros" class="c-about">
        <div class="container">
          <div class="row gy-5 justify-content-center">
            <div data-aos="fade-right" class="col-12 col-md-6 col-lg-4">
              <h2  class="sec-light fs-16 w-sbold line-height mb-3">
                {{context.nosotros.subtitulo}}
              </h2>
              <h2 v-html="titulos.nosotros" class="c-about__title mb-4">
              </h2>
              <div class="d-flex">
                <a href="#contact" class="c-button c-button--primary">
                  {{context.nosotros.boton_titulo}}
                </a>
              </div>
            </div>
            <div data-aos="fade-up" class="col-12 col-md-6 col-lg-4">
              <h2 class="white fs-16 w-bold line-height mb-3">
                {{context.nosotros.titulo_descripcion}}
              </h2>
              <p class="sec-light fs-16 w-medium line-height mb-0 pe-4">
                {{context.nosotros.descripcion}}
              </p>
            </div>
            <div data-aos="fade-left" class="col-12 col-md-6 col-lg-4">
              <h2 class="white fs-16 w-bold line-height mb-3">
                {{context.nosotros.titulo_estadisticas}}
              </h2>
              <div class="c-about__statistics">
                <div
                  v-for="(item,i) of context.nosotros.estadisticas.slice(0,4)"
                  :key="`item-${i}`"
                  >
                  <h2 class="white fs-40 w-black">
                    {{item.numero}}+
                  </h2>
                  <p class="sec-light fs-18 w-medium line-height">
                    {{item.label}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="c-about__images pt-5">
            <div class="c-about__container container p-0">
              <div class="row g-5">
                <div
                  v-for="(item,i) of context.nosotros.galeria.slice(0,2)"
                  :key="`item-${i}`"
                  data-aos="fade-up"
                  :data-aos-delay="100 * (i + 1)"
                  class="col-12 col-lg-6">
                  <div class="c-about__image">
                    <img :src="item.imagen" alt="" class="w-100 h-100 of--cover">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.servicios" class="c-services" id="services">
        <div class="container">
          <div class="mb-5 container">
            <div class="row justify-content-center">
              <div data-aos="fade-up" class="col-12 col-md-10 col-lg-6">
                <h2 class="text-center sec-alt fs-16 w-sbold line-height mb-3">
                  {{context.servicios.subtitulo}}
                </h2>
                <h2 v-html="titulos.servicios" class="c-services__title mb-3">
                </h2>
                <p class="text-center sec-alt fs-16 w-sbold line-height">
                  {{context.servicios.descripcion}}
                </p>
              </div>
            </div>
          </div>
          <div v-if="context.serviciosList" class="mb-5 pb-5 container p-0">
            <div class="row gy-5 justify-content-center">
              <div
                v-for="(item,i) of (context.serviciosList).slice(0, 4)"
                :key="`item-${i}`"
                data-aos="fade-up"
                :data-aos-delay="100 * (i + 1)"
                class="col-12 col-md-6 col-lg-3">

                <a :href="`/servicio/${item.slug}`"
                  class="h-100 d-flex flex-column c-briefcase--service">
                  <div class="c-briefcase__logo">
                    <img :src="item.thumbnail" alt="" class="c-briefcase__img">
                  </div>
                  <div class="c-briefcase__title-card d-flex">
                    <h2>
                      {{item.title}}
                    </h2>
                  </div>
                </a>
              </div>
            </div>
            <div data-aos="fade-up" class="text-center d-flex justify-content-center mt-5">
              <div class="col-12 col-md-6 col-lg-3">
                <a :href="`/servicios`"
                  class="h-100 d-flex flex-column c-briefcase--service c-briefcase--flat">
                  <div class="c-briefcase__title-card d-flex">
                    <h2 class="d-flex align-items-center fs-21">
                      <span class="p-1">Ver más</span> <Icon icon="ic:round-plus" class="fs-30"/>
                    </h2>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <Fancybox
            :options="{
              Carousel: {
                infinite: false,
                autoSize: true
              },
            }"
          >
            <div class="position-relative">
              <div id="slider-services" class="c-slider-services swiper h-100">
                <div class="swiper-wrapper position-relative h-100">
                  <div
                    v-for="(item,i) of context.servicios.galeria"
                    :key="`item-${i}`"
                    class="swiper-slide h-100">
                    <a
                      data-aos="fade-up"
                      :data-aos-delay="100 * (i + 1)"
                      class="c-services-slider">
                      <div class="c-services-slider__container">
                        <img
                          :src="item.imagen.sizes.medium_large"
                          class="c-services-slider__image"
                        >
                        <a
                          data-fancybox="gallery"
                          :href="item.imagen.url"
                          class="c-services-slider__gradient">
                          <span class="c-services-slider__mapa">
                            <Icon icon="heroicons:magnifying-glass-plus"/>
                          </span>
                        </a>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-pagination mt-4" cursor="pointer"></div>
              </div>
              <button id="slider-services-prev" class="slider-services-prev">
                <Icon icon="ooui:arrow-previous-ltr"/>
              </button>
              <button id="slider-services-next" class="slider-services-next">
                <Icon icon="ooui:arrow-previous-rtl"/>
              </button>
            </div>
          </Fancybox>
        </div>
      </div>
      <div ref="container">
        <slot></slot>
      </div>
      <div v-if="context.certificados" class="c-certificates">
        <div class="container">
          <div class="row justify-content-center">
            <div data-aos="fade-up" class="col-10 col-md-8 col-lg-6">
              <h2 class="text-center sec-alt fs-16 w-sbold line-height mb-3">
                {{context.certificados.subtitulos}}
              </h2>
              <h2 v-html="titulos.certificados" class="c-certificates__title mb-4">
              </h2>
            </div>

            <div data-aos="fade-up" class="col-10 col-md-10 col-lg-10">
              <div class="c-certificates__info sec-alt fs-16 text-center pb-4">
                <p class="mb-4">
                  {{context.certificados.descripcion}}
                </p>
              </div>
            </div>
          </div>
          <div id="slider-certificate" class="c-slider-certificate swiper mt-3">
            <div class="swiper-wrapper position-relative align-items-stretch"
              :class="{'not-full' : context.certificados.certificados.length < 4}"
            >
            <!-- h-100 -->
              <div
                v-for="(item,i) of context.certificados.certificados"
                :key="`item-${i}`"
                class="swiper-slide ">
                <div
                  class="c-certificate-card"
                  data-aos="fade-up"
                  :data-aos-delay="100 * (i + 1)"
                >
                  <div class="gap-3">
                    <!-- <div>
                      <h2 class="sec-color fs-18 w-xbold mb-4 text-center">
                        {{item.titulo}}
                      </h2>
                    </div> -->
                    <div class="mb-3">
                      <figure class="c-certificate-card__icon text-center">
                        <img :src="item.icono" alt="" class="h-100 w-100 of--contain">
                      </figure>
                    </div>
                  </div>
                  <!-- <p class="sec-alt fs-16 w-regular line-height h-100">
                    {{item.descripcion}}
                  </p> -->
                  <a
                    :href="item.archivo" target="_blank"
                    class="c-certificate-card__link text-center">
                    <span>
                      <Icon icon="fa6-regular:file-pdf"/>
                    </span>
                    Ver certificado
                  </a>
                </div>
              </div>
            </div>
            <div class="swiper-pagination mt-4" cursor="pointer"></div>
          </div>
        </div>
      </div>
      <div v-if="context.politicas" class="c-politics">
        <img :src="context.politicas.fondo" alt="" class="c-politics__background">
        <div class="c-politics__gradient"></div>
        <div class="container">
          <div class="c-politics__container container">
            <div class="row justify-content-center align-items-stretch">
              <div data-aos="fade-up" class="col-10 col-md-6 col-lg-4">
                <h2 class="text-center sec-xlight fs-16 w-sbold line-height mb-3">
                  {{context.politicas.subtitulo}}
                </h2>
                <h2 v-html="titulos.politicas" class="c-politics__title mb-4">
                </h2>
              </div>
            </div>
            <div
              id="slider-politics" class="c-slider-politics swiper"
            >
              <div
                class="swiper-wrapper position-relative"
                :class="{'not-full' : context.politicas.politicas.length < 4}"
              >
              <!-- h-100 -->
                <div
                  v-for="(item,i) of context.politicas.politicas"
                  :key="`item-${i}`"
                  class="swiper-slide">
                  <div
                    class="c-politics-card"
                    data-aos="fade-up"
                    :data-aos-delay="100 * (i + 1)"
                    >
                    <div class="d-flex gap-3 mb-4">
                      <div>
                        <figure class="c-politics-card__icon">
                          <img :src="item.icono" alt="" class="w-100 of--contain">
                        </figure>
                      </div>
                      <div class="h-100">
                        <h2 class="sec-xlight fs-16 w-medium mb-1">
                          Política
                        </h2>
                        <h2 class="c-politics-card__title white fs-18 w-xbold mb-0">
                          {{item.titulo}}
                        </h2>
                      </div>
                    </div>
                    <p class="sec-wlight fs-16 w-regular line-height h-100">
                      {{item.descripcion}}
                    </p>
                    <a :href="item.archivo" class="c-politics-card__link" target="_blank">
                      <span>
                        <Icon icon="fa6-regular:file-pdf"/>
                      </span>
                      Ver política
                    </a>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination mt-4" cursor="pointer"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.contacto" class="c-contact" id="contact">
        <div class="container">
          <div class="row justify-content-center gy-5">
            <div data-aos="fade-right" class="col-12 col-lg-5">
              <div class="">
                <h2 class="sec-alt fs-16 w-sbold line-height mb-3">
                  {{context.contacto.subtitulo}}
                </h2>
                <h2 v-html="titulos.contacto" class="c-contact__title mb-4 me-lg-5">
                </h2>
                <div v-if="general.data.information">
                  <div
                    data-aos="fade-right"
                    :data-aos-delay="100 * (0 + 1)"
                    class="d-flex gap-3 align-items-center mb-5">
                    <figure class="c-contact__icon">
                      <img src="@/assets/images/phone.png" alt="" class="h-100 of--contain">
                    </figure>
                    <div>
                      <p class="sec-color fs-21 w-bold mb-1">
                        Teléfonos
                      </p>
                      <p class="sec-alt fs-18 w-sbold mb-0">
                        {{general.data.information.telephone}} / {{general.data.information.phone}}
                      </p>
                    </div>
                  </div>
                  <div
                    data-aos="fade-right"
                    :data-aos-delay="100 * (1 + 1)"
                    class="d-flex gap-3 align-items-center mb-5">
                    <figure class="c-contact__icon">
                      <img src="@/assets/images/mail.png" alt="" class="h-100 of--contain">
                    </figure>
                    <div>
                      <p class="sec-color fs-21 w-bold mb-0">
                        Email
                      </p>
                      <p class="sec-alt fs-18 w-sbold mb-0">
                        {{general.data.information.email}}
                      </p>
                    </div>
                  </div>
                  <div
                    data-aos="fade-right"
                    :data-aos-delay="100 * (2 + 1)"
                    class="d-flex gap-3 align-items-center">
                    <figure class="c-contact__icon">
                      <img src="@/assets/images/location.png" alt="" class="h-100 of--contain">
                    </figure>
                    <div>
                      <p class="sec-color fs-21 w-bold mb-0">
                        Dirección
                      </p>
                      <p class="sec-alt fs-18 w-sbold mb-0">
                        {{general.data.information.address}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-left" class="col-12 col-lg-7">
              <ContactForm></ContactForm>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>

    <b-modal
    id="modalGallery"
      title="BootstrapVue" hide-footer hide-header hide-actions centered size="xl"
    >
      <div class="c-modal c-modal--gallery">
        <div class="text-end mt-0">
          <div class="text-end pe-3 pt-2 position-absolute c-modal__cross">
            <span @click="$bvModal.hide('modalGallery')" class=" fs-30">
              <Icon icon="gridicons:cross-circle" />
            </span>
          </div>
        </div>
        <div class="pt-0 w-100 h-100">
          <img
            :src="modalGalleryImageUrl"
            class="w-100 h-100 of--contain"
          >
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  requiredIf,
} from 'vuelidate/lib/validators';
import {
  Swiper,
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default {
  data() {
    return {
      sliderBanner: null,
      sliderServices: null,
      sliderCertificate: null,
      sliderPolitics: null,

      attachment: '',

      submitStatus: '',

      context: {},
      contextLoading: true,
      titulos: {
        nosotros: '',
        servicios: '',
        certificados: '',
        politicas: '',
        contacto: '',
      },
      modalGalleryImageUrl: '',
    };
  },
  computed: {
    ...mapState(['general']),
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'home' });
  },
  validations: {
    attachment: {
      file: {
        required: requiredIf(function file() {
          return this.attachment.length === 0;
        }),
      },
    },
  },
  mounted() {
    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });
  },
  updated() {
    Fancybox.unbind(this.$refs.container);
    Fancybox.close();

    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });
  },
  unmounted() {
    Fancybox.destroy();
  },
  components: {
    ContactForm: () => import(/* webpackChunkName: "contact-form" */'@/components/ContactForm.vue'),
  },

  watch: {
    contextLoading(state) {
      if (!state) {
        this.initBannerSlider();
        this.initServicesSlider();
        setTimeout(() => {
          this.initCertificateSlider();
          this.initPoliticsSlider();
        }, 200);

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.context.post.content;
        this.titulos.nosotros = tempDiv.getElementsByTagName('h2')[0].innerHTML;
        this.titulos.servicios = tempDiv.getElementsByTagName('h2')[1].innerHTML;
        this.titulos.certificados = tempDiv.getElementsByTagName('h2')[2].innerHTML;
        this.titulos.politicas = tempDiv.getElementsByTagName('h2')[3].innerHTML;
        this.titulos.contacto = tempDiv.getElementsByTagName('h2')[4].innerHTML;
      }
    },
  },
  methods: {
    initBannerSlider() {
      window.setTimeout(() => {
        this.sliderBanner = new Swiper('#slider-banner', {
          modules: [Navigation, Pagination, Autoplay],

          autoHeight: true,
          speed: 1500,
          // loop: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          pagination: {
            el: '#slider-banner .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-banner-prev',
            nextEl: '#slider-banner-next',
          },
        });
      }, 100);
    },

    initServicesSlider() {
      window.setTimeout(() => {
        this.sliderServices = new Swiper('#slider-services', {
          modules: [Navigation, Pagination, Autoplay],
          speed: 1500,
          // loop: true,
          autoHeight: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
          },

          pagination: {
            el: '#slider-services .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-services-prev',
            nextEl: '#slider-services-next',
          },
        });
      }, 100);
    },

    initCertificateSlider() {
      window.setTimeout(() => {
        this.sliderCertificate = new Swiper('#slider-certificate', {
          modules: [Navigation, Pagination, Autoplay],
          // autoHeight: true,
          speed: 1500,
          // loop: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 25,

            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
          },

          pagination: {
            el: '#slider-certificate .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-certificate-prev',
            nextEl: '#slider-certificate-next',
          },
        });
      }, 100);
    },

    initPoliticsSlider() {
      window.setTimeout(() => {
        this.sliderPolitics = new Swiper('#slider-politics', {
          modules: [Navigation, Pagination, Autoplay],

          // autoHeight: true,
          speed: 1500,
          // loop: true,
          spaceBetween: 0,
          // centeredSlides: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
          },

          pagination: {
            el: '#slider-politics .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-politics-prev',
            nextEl: '#slider-politics-next',
          },
        });
      }, 100);
    },

    asd() {
      return this.attachment.length !== 0;
    },
    attachmentFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.attachment = '';

        return;
      }

      [this.attachment] = files;
    },

    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        this.submitStatus = 'PENDING';
        /* OK code here!!! */
      }
    },
    openGallery(url) {
      this.modalGalleryImageUrl = url;
      console.log(this.modalGalleryImageUrl, 'assss');
      this.$bvModal.show('modalGallery');
    },
  },
};
</script>
